import { ICON_TYPE_TO_TEXT_MAPPER } from '@/shared/consts';
import type { ESchoolBadgeIcons } from '@/shared/types';

import styles from './IconSelectLabel.module.scss';

interface IProp {
  iconType: ESchoolBadgeIcons;
  textClassName?: string;
}

export const IconSelectLabel = ({ iconType, textClassName }: IProp) => (
  <div className={styles.wrapper}>
    <img
      className={styles.icon}
      src={`/images/schoolBadgeIcons/${iconType}.svg`}
      width={28}
      height={28}
      alt="Один из возможных логотипов школы"
    />
    <p className={textClassName}>{ICON_TYPE_TO_TEXT_MAPPER[iconType]}</p>
  </div>
);
